export default "__VITE_ASSET__DOvUsSGx__"